import { BaseException } from "@/exceptions/base-exception.exception"
import { ExceptionWeights } from "@/enums/exceptions/exception-weights"
import { type IInstructionFeedbackActivity } from "@/interfaces/api/instruction-feedback-activity.interface"
import { InstructionFeedbackActivity } from "@/models/instruction-feedback-activity.model"
import moment from "moment"

export class CannotDeleteWorkPeriodWithLinkedFeedbackActivitiesException extends BaseException {
  exceptionId = "CANNOT_DELETE_WORK_PERIOD_WITH_LINKED_FEEDBACK_ACTIVITIES"
  title = "Kan dienst niet verwijderen"
  weight = ExceptionWeights.ERROR

  private readonly linkedFeedbackActivities: InstructionFeedbackActivity[]

  constructor(linkedFeedbackActivities: IInstructionFeedbackActivity[]) {
    super()
    this.linkedFeedbackActivities = linkedFeedbackActivities.map(
      (ifa) => new InstructionFeedbackActivity(ifa)
    )
  }

  public getMessage(): string {
    const feedbackActivitiesMessage = this.linkedFeedbackActivities
      .map((ifa, index) => {
        const typeString = index === 0 ? ifa.getTypeString() : ifa.getTypeString().toLowerCase()
        let timeString = ""

        if (ifa.timeStart && moment(ifa.timeStart).isValid()) {
          timeString += ` van ${moment(ifa.timeStart).format("HH:mm")} uur`
        }
        if (ifa.timeEnd && moment(ifa.timeEnd).isValid()) {
          timeString += ` tot ${moment(ifa.timeEnd).format("HH:mm")} uur`
        }

        return `${typeString}${timeString}`
      })
      .join(", ")

    return `Er zijn nog werkzaamheden aan gekoppeld:\n${feedbackActivitiesMessage}`
  }
}
